import { Button, DropdownMenu } from 'components/atoms';
import { useComponentVisible } from 'hooks';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { PiDownload } from 'react-icons/pi';
import { IButtonProps } from 'types/components/button/button.interface';
import { IJustifyPositionProps } from 'types/components/components.interface';

import { handleDownloadFile } from 'utils/global/linkToUrl.utils';

interface IPdfDownloadButtonProps extends IButtonProps, IJustifyPositionProps {
  withText?: boolean;
  pdf1Url?: string;
  pdf2Url?: string;
}

const PdfDownloadButton = ({
  withText = true,
  justifyPosition = 'center',
  pdf1Url,
  pdf2Url,
  ...props
}: IPdfDownloadButtonProps) => {
  const { t } = useTranslation();

  const { ref, isComponentVisible, handleComponentVisible } =
    useComponentVisible<HTMLDivElement>(false);

  const onDownload = (pdfUrl: string) => {
    handleDownloadFile(pdfUrl);
    handleComponentVisible();
    toast.success(t('toast-message.pdf-downloaded-successfully'));
  };

  return (
    <Button
      onClick={handleComponentVisible}
      onlyIcon={!withText}
      outsideChildren={
        <DropdownMenu
          ref={ref}
          visible={isComponentVisible}
          justifyPosition={justifyPosition}
          style={{ padding: 4 }}>
          <div>
            {pdf1Url && (
              <a href={pdf1Url} onClick={() => onDownload(pdf1Url)}>
                <Button isClear fullWidth>
                  <Button.Text text={`.pdf (${t('button.advance')})`} />
                </Button>
              </a>
            )}
            {pdf2Url && (
              <a href={pdf2Url} onClick={() => onDownload(pdf2Url)}>
                <Button isClear fullWidth>
                  <Button.Text text={`.pdf (${t('button.final')})`} />
                </Button>
              </a>
            )}
          </div>
        </DropdownMenu>
      }
      {...props}>
      {!withText && (
        <Button.Description description={t('button.download')} />
      )}
      {withText && <Button.Text text={t('button.download')} />}
      <Button.Icon icon={<PiDownload />} />
    </Button>
  );
};

export default PdfDownloadButton;
